module.exports = __webpack_public_path__ + "img/11400.77224e49.jpg";